import { render, staticRenderFns } from "./m-addQuestionSNPMB.vue?vue&type=template&id=60311b9c&"
import script from "./m-addQuestionSNPMB.vue?vue&type=script&lang=js&"
export * from "./m-addQuestionSNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports